module.exports = __webpack_public_path__ + "img/fond_conseil_departemental_haut_rhin.89163df3.jpg";